/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
export const ASSET_ID_LABEL = 'Asset Id'
export const ASSET_LICENSING_BATCH_LABEL = 'Asset Licensing Batch'
export const ASSET_LICENSING_BATCH_NAME_LABEL = 'Asset Licensing Batch Name'
export const CREATOR_LABEL = 'Creator'
export const FILE_TYPE_LABEL = 'File type'
export const LISTING_BATCH_LABEL = 'Listing Batch'
export const LISTING_BATCH_LABEL_FILTER_LABEL = `${LISTING_BATCH_LABEL} Name`
export const MANAGE_LABEL = 'Manage'
export const PUBLISHER_LABEL = 'Publisher'
export const REGISTRATION_BATCH = 'Registration Batch'
export const REGISTRATION_BATCH_FILTER_LABEL = `${REGISTRATION_BATCH} Name`
export const SAM_BUILDING_BATCH_LABEL = 'SAM Building Batch'
export const SAM_BUILDING_BATCH_FILTER_LABEL = `${SAM_BUILDING_BATCH_LABEL} Name`
export const SAM_LISTING_BATCH_LABEL = 'SAM Listing Batch'
export const TITLE_LABEL = 'Title'
